<template>
  <form name="orgLoginForm" class="form-horizontal" role="form" data-vv-scope="form1" novalidate @keyup.13="validateForm('form1')">
    <div class="form-group xo-login-box-form-group xo-row-gap xo-login-box-form-padding">
      <label class="col-sm-2 col-md-2 control-label">用户名</label>
      <div class="col-sm-10 col-md-10">
        <input v-validate="'required'" v-model="form1.accountName" name="phone" type="text" placeholder="手机号/邮箱/工号"  class="form-control xo-login-box-form-control" id="userphone">
      </div>
    </div>
    <div class="form-group xo-login-box-form-group xo-row-gap xo-login-box-form-padding">
      <label class="col-sm-2 col-md-2 control-label">密码</label>
      <div class="col-sm-10 col-md-10">
        <input v-validate="'required'" v-model="form1.password" name="password" type="password" placeholder="密码" class="form-control xo-login-box-form-control">
      </div>
    </div>
    <div v-if="login_auth_required" class="form-group xo-login-box-form-group xo-row-gap xo-login-box-form-padding">
      <div class="col-sm-8 col-md-8">
        <input v-validate="'required'" v-model="form1.verify" name="verify" type="text" placeholder="输入验证码" class="form-control xo-login-box-form-control">
      </div>
      <div class="col-sm-4 col-md-4" style="padding-left: 0; padding-right: 0; height: 38px;">
        <label @click="refreshPicCode">
          <pic-auth-code :identify-code="login_auth_required"></pic-auth-code>
        </label>
      </div>
    </div>
    <div class="form-group xo-login-box-form-padding">
      <button type="button" class="xo-btn xo-btn-block" @click="validateForm('form1')">登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
    </div>
    <div class="form-group xo-login-box-form-padding">
      <a href="#" id="rememberMe" class="xo-rememberMe">
        <input type="checkbox" id="checkbox-1-1" class="xo-checkbox" v-model="form1.checked" @click="rme(form1.checked)" /><label for="checkbox-1-1"></label>&nbsp;&nbsp;记住我
      </a>
      <a id="pwdForget" class="xo-pwdForget" @click="toFindPwd">忘记密码?</a>
    </div>
  </form>
</template>
<script>
  import getAuthCode from '@/components/common/common/getAuthCode.vue'
  import picAuthCode from '@/components/common/common/picAuthCode.vue'
  import utils from '@/utils'
  import { getCookie, removeCookie } from '@/store/cookies.js'
  import { mapState, mapActions } from 'vuex'
  import '@/utils/validator.js'
  export default {
    components: { getAuthCode, picAuthCode },
    mounted () {
      var userSession = getCookie('rme_fresh') // 取记住我cookie值
      if (userSession) {
        this.form1.accountName = userSession.phone
        this.form1.password = userSession.password
        this.form1.checked = true
      }
      if (this.login_auth_required) {
        this.clearLoginAuth()
      }
    },
    data () {
      return {
        form1: {} // 普通登录
      }
    },
    computed: {
      ...mapState('auth', ['login_auth_required']),
      tabClass () {
        return {
          current: this.currentTab.isActive === true
        }
      }
    },
    methods: {
      ...mapActions('auth', ['getPicCode', 'clearLoginAuth']),
      toFindPwd () {
        var domain = utils.getQueryString('domain')
        if (utils.getQueryString('h')) {
          window.location.href = window.location.origin + '/#/byl/findpwd?h=' + utils.getQueryString('h') + '&domain=' + domain
        } else {
          window.location.href = window.location.origin + '/#/byl/findpwd?domain=' + domain
        }
      },
      popup (msg) {
        this.$toasted.show(msg)
      },
      getCode () { // 验证码登录获取手机验证码
        this.$emit('ready-to-get-code', this.form2.phone)
      },
      refreshPicCode () {
        this.getPicCode()
      },
      rme (checked) {
        if (checked) { // 删除cookie
          removeCookie('rme_fresh')
        }
      },
      validateForm (scope) {
        var bus = this
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            bus.login()
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      login () {
        let form = this.form1
        this.$emit('ready-for-login', form)
      }
    },
    props: ['user']
  }
</script>
<style scoped>
  @import './bootstrap/3.0.2/css/bootstrap.min.css';
  @import './hsm.css';
</style>



// WEBPACK FOOTER //
// src/page/hsm/loginForm.vue